import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { getProjectKeyOrId } from '@jira/router-resources__utils/src/getProjectKeyOrId.tsx';
import type { CaseNoteForm } from './CaseNoteForm.types.tsx';

const RESOURCE_TYPE_CASE_NOTE_FORMS = 'CASE_NOTE_FORMS';

export const caseNoteFormsResource: RouteResource<CaseNoteForm[]> = createResource<CaseNoteForm[]>({
	type: RESOURCE_TYPE_CASE_NOTE_FORMS,
	getKey: ({ match }) => getProjectKeyOrId(match),
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-case-note-forms", jiraSpaEntry: "async-resource-servicedesk-case-note-forms" */ './getData.tsx'
		),
	maxAge: 5 * 60 * 1000,
});
